import { getStoresByCoords, getStoresByCountry } from 'actions/shops';

import { getMarket, postalCodePattern } from './helpers';

export const isStoreAustralia = (stores, storeId) => storeId.toUpperCase() === stores.STORE_AU;
export const isStoreBrasil = (stores, storeId) => storeId.toUpperCase() === stores.STORE_BR;
export const isStoreChina = (stores, storeId) => storeId.toUpperCase() === stores.STORE_CN;
export const isStoreColombia = (stores, storeId) => storeId.toUpperCase() === stores.STORE_CO;
export const isStoreHongKong = (stores, storeId) => storeId.toUpperCase() === stores.STORE_HK;
export const isStoreJapan = (stores, storeId) => storeId.toUpperCase() === stores.STORE_JP;
export const isStoreKorea = (stores, storeId) => storeId.toUpperCase() === stores.STORE_KR;
export const isStoreMexico = (stores, storeId) => storeId.toUpperCase() === stores.STORE_MX;
export const isStoreRusia = (stores, storeId) => storeId.toUpperCase() === stores.STORE_RU;
export const isStoreThailand = (stores, storeId) => storeId.toUpperCase() === stores.STORE_TH;
export const isStoreTurkey = (stores, storeId) => storeId.toUpperCase() === stores.STORE_TURKEY;
export const isStoreTaiwan = (stores, storeId) => storeId.toUpperCase() === stores.STORE_TW;
export const isStoreUsa = (stores, storeId) => storeId.toUpperCase() === stores.STORE_USA;
export const isStoreWorld = (stores, storeId) => storeId.toUpperCase() === stores.STORE_WORLD;

const BOUNDARY_CLASS = 'boundary';
const PLACE_CLASS = 'place';
const allowedClasses = [BOUNDARY_CLASS, PLACE_CLASS];

export const handleNominatimResult = async (locale, res, onSuccess, onFailure) => {
  let results = [null, null, null];

  // si res tiene una length de 1 es un reverse

  const sortedResponse =
    res.length === 1 ?
      res
    : res.sort((a, b) => {
        // if boundary vs place boundary wins (-1)
        // if boundary vs boundary, boundary without city wins (-1)
        // equal

        if (a.class === BOUNDARY_CLASS && b.class === BOUNDARY_CLASS) {
          const [{ address: addressA }, { address: addressB }] = [a, b];
          const aHasCity = 'city' in addressA;
          const bHasCity = 'city' in addressB;

          if ((aHasCity && bHasCity) || (!aHasCity && !bHasCity)) {
            return 0;
          }

          if (aHasCity && !bHasCity) {
            return 1;
          }

          if (!aHasCity && bHasCity) {
            return -1;
          }
        }

        let defaultReturn = 0;

        if (a.class !== BOUNDARY_CLASS) defaultReturn = defaultReturn + 1;
        if (b.class !== BOUNDARY_CLASS) defaultReturn = defaultReturn - 1;

        return defaultReturn;
      });

  for (let i = 0; i < sortedResponse.length; i++) {
    const auxItem = sortedResponse[i];

    if (allowedClasses.includes(auxItem.class) || res.length === 1) {
      // si es un reverse nos saltamos el check de clase
      const { lon, lat, address, boundingbox } = auxItem;

      const { city, country_code, province, county, administrative, state, municipality } = address;

      // un country no tiene administrative solo tiene country y country_code
      const isCountry = country_code && !administrative && !state && !county && !province && !city && !municipality;
      const apiMethod = isCountry ? getStoresByCountry : getStoresByCoords;
      let apiParams = [null, locale];

      // mandar boundingbox en base a mapeo back
      if (isCountry) {
        apiParams = [...apiParams, country_code];
      } else if (boundingbox && res.length !== 1) {
        // lat 1 north lat2 south lon1 west lon2 east
        const [south, north, west, east] = boundingbox;
        apiParams = [...apiParams, country_code, south, west, north, east];
      } else {
        apiParams = [...apiParams, country_code, lat, lon];
      }

      try {
        const result = await apiMethod(...apiParams);

        const { stores, cities } = result;

        if (stores.length > 0) {
          results = [auxItem, stores, cities];
          break;
        }
      } catch (e) {
        onFailure();
      }
    }
  }

  if (results[0] === null) {
    onFailure();
  } else {
    onSuccess(...results);
  }
};

export const checkPostalCode = (locale, searchString) => {
  const country = getMarket(locale);

  const postalCodeReg = postalCodePattern[country];

  if (postalCodeReg === undefined) {
    console.log('no postal code regexp for current country: ', country);
    return false;
  }

  const isPostalCode = postalCodeReg.test(searchString);

  return isPostalCode;
};
